/**
 * @generated SignedSource<<aa025ac439b416a5321ca0c6f97dc5bd>>
 * @relayHash fcc81036b313cdc379e986cf0a3136da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cc10cd43053a8820b5cdd778d95d9c93f16c20b4910bb0240ea20f73dbdfb458

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "UNKNOWN" | "%future added value";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum = "CLOSED" | "IGNORED" | "OPEN" | "UNKNOWN" | "%future added value";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum = "DAST" | "SAST" | "SCA" | "UNKNOWN" | "%future added value";
export type GraphQueryMetadataSortEnum = "ASC" | "DESC" | "%future added value";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInput = {
  and?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputAnd> | null | undefined;
  or?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputOr> | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputAnd = {
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null | undefined;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null | undefined;
  or?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputOrInner> | null | undefined;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null | undefined;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null | undefined;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null | undefined;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt = {
  range?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtRangeField | null | undefined;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtMetadataSortField | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtRangeField = {
  gt?: AGG$DateTime | null | undefined;
  gte?: AGG$DateTime | null | undefined;
  lt?: AGG$DateTime | null | undefined;
  lte?: AGG$DateTime | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null | undefined;
  priority?: number | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated = {
  range?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedRangeField | null | undefined;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedMetadataSortField | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedRangeField = {
  gt?: AGG$DateTime | null | undefined;
  gte?: AGG$DateTime | null | undefined;
  lt?: AGG$DateTime | null | undefined;
  lte?: AGG$DateTime | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null | undefined;
  priority?: number | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputOrInner = {
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null | undefined;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null | undefined;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null | undefined;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null | undefined;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null | undefined;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer = {
  containerAri?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAri | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAri = {
  value?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValue | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValue = {
  notValues?: ReadonlyArray<string> | null | undefined;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValueMetadataSortField | null | undefined;
  values?: ReadonlyArray<string> | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValueMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null | undefined;
  priority?: number | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity = {
  notValues?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum> | null | undefined;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverityMetadataSortField | null | undefined;
  values?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum> | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverityMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null | undefined;
  priority?: number | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus = {
  notValues?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum> | null | undefined;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatusMetadataSortField | null | undefined;
  values?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum> | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatusMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null | undefined;
  priority?: number | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToType = {
  notValues?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum> | null | undefined;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToTypeMetadataSortField | null | undefined;
  values?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum> | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToTypeMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null | undefined;
  priority?: number | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputOr = {
  and?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputAndInner> | null | undefined;
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null | undefined;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null | undefined;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null | undefined;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null | undefined;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null | undefined;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null | undefined;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputAndInner = {
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null | undefined;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null | undefined;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null | undefined;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null | undefined;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null | undefined;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null | undefined;
};
export type mainSecurityInJiraQuery$variables = {
  cloudAri: string;
  cloudId: string;
  filter?: GraphQueryMetadataProjectAssociatedVulnerabilityInput | null | undefined;
  getContainers: boolean;
  isVulnsListFixEnabled: boolean;
  numberOfContainersToFetch: number;
  numberOfVulnsToFetch: number;
  projectKey: string;
};
export type mainSecurityInJiraQuery$data = {
  readonly devOps: {
    readonly providers: {
      readonly securityProviders: ReadonlyArray<{
        readonly appInstallationId: string | null | undefined;
        readonly id: string;
        readonly linkedWorkspaces: {
          readonly nodes: ReadonlyArray<{
            readonly __typename: "AriGraphRelationship";
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly logoUrl: AGG$URL | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly linkedSecurityContainers: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly to: {
              readonly data?: {
                readonly providerId?: string | null | undefined;
              } | null | undefined;
            };
          };
        } | null | undefined> | null | undefined;
      };
      readonly linkedVulnsForAnalytics: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly vulnerability?: {
              readonly securityContainer: {
                readonly providerId: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
          };
        } | null | undefined>;
      } | null | undefined;
      readonly totalLinkedSecurityContainerCount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"main_softwareSecurityPage_MainPage">;
    };
  } | null | undefined;
};
export type mainSecurityInJiraQuery = {
  response: mainSecurityInJiraQuery$data;
  variables: mainSecurityInJiraQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "getContainers"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVulnsListFixEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfContainersToFetch"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfVulnsToFetch"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v9 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v10 = {
  "kind": "ScalarField",
  "name": "totalLinkedSecurityContainerCount"
},
v11 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "numberOfContainersToFetch"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "ThirdPartySecurityContainer"
},
v15 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v16 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "numberOfVulnsToFetch"
},
v17 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "and": {
        "lastUpdated": {
          "sort": {
            "order": "ASC",
            "priority": 1
          }
        }
      }
    }
  },
  (v16/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "ScalarField",
  "name": "name"
},
v20 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v21 = {
  "concreteType": "DevOps",
  "kind": "LinkedField",
  "name": "devOps",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "cloudAri"
        },
        {
          "kind": "Literal",
          "name": "providerTypes",
          "value": [
            "SECURITY"
          ]
        }
      ],
      "concreteType": "DevOpsProviders",
      "kind": "LinkedField",
      "name": "providers",
      "plural": false,
      "selections": [
        {
          "concreteType": "DevOpsSecurityProvider",
          "kind": "LinkedField",
          "name": "securityProviders",
          "plural": true,
          "selections": [
            (v18/*: any*/),
            {
              "kind": "ScalarField",
              "name": "appInstallationId"
            },
            {
              "kind": "ScalarField",
              "name": "logoUrl"
            },
            (v19/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 100
                }
              ],
              "concreteType": "AriGraphRelationshipConnection",
              "kind": "LinkedField",
              "name": "linkedWorkspaces",
              "plural": false,
              "selections": [
                {
                  "concreteType": "AriGraphRelationship",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v20/*: any*/)
                  ]
                }
              ],
              "storageKey": "linkedWorkspaces(first:100)"
            }
          ]
        }
      ]
    }
  ]
},
v22 = [
  (v18/*: any*/)
],
v23 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v24 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "DevOpsFeatureFlag"
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "DevOpsOperationsComponentDetails"
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "DevOpsOperationsIncidentDetails"
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "DevOpsOperationsPostIncidentReviewDetails"
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "DevOpsPullRequestDetails"
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "DevOpsRepository"
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "DevOpsSecurityVulnerabilityDetails"
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "JiraAutodevJob"
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "JiraConfluenceRemoteIssueLink"
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "JiraCustomRemoteIssueLink"
},
v34 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "JiraIssueRemoteIssueLink"
},
v35 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "JiraWebRemoteIssueLink"
},
v36 = [
  (v9/*: any*/),
  (v16/*: any*/)
],
v37 = {
  "kind": "ScalarField",
  "name": "url"
},
v38 = {
  "kind": "ScalarField",
  "name": "key"
},
v39 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v40 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v41 = [
  {
    "concreteType": "GraphJiraVulnerabilityEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "GraphJiraVulnerability",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevOpsSecurityVulnerabilityDetails",
            "kind": "LinkedField",
            "name": "vulnerability",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v18/*: any*/)
            ]
          },
          (v18/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainSecurityInJiraQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v8/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                {
                  "args": [
                    (v9/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "getContainers",
                      "variableName": "getContainers"
                    },
                    {
                      "kind": "Variable",
                      "name": "isVulnsListFixEnabled",
                      "variableName": "isVulnsListFixEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "numberOfContainersToFetch",
                      "variableName": "numberOfContainersToFetch"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "main_softwareSecurityPage_MainPage"
                },
                (v10/*: any*/),
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v11/*: any*/),
                    "concreteType": "AriGraphRelationshipConnection",
                    "kind": "LinkedField",
                    "name": "linkedSecurityContainers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationshipEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationship",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AriGraphRelationshipNode",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v15/*: any*/)
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                },
                {
                  "alias": "linkedVulnsForAnalytics",
                  "args": (v17/*: any*/),
                  "concreteType": "GraphJiraVulnerabilityConnection",
                  "kind": "LinkedField",
                  "name": "linkedSecurityVulnerabilitiesByProject",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "GraphJiraVulnerabilityEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "GraphJiraVulnerability",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "condition": "getContainers",
                              "kind": "Condition",
                              "passingValue": true,
                              "selections": [
                                {
                                  "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                  "kind": "LinkedField",
                                  "name": "vulnerability",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "ThirdPartySecurityContainer",
                                      "kind": "LinkedField",
                                      "name": "securityContainer",
                                      "plural": false,
                                      "selections": (v13/*: any*/)
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "jira.jiraProjectByKey"
          }
        ]
      },
      (v21/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainSecurityInJiraQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v18/*: any*/),
              {
                "args": (v11/*: any*/),
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "linkedSecurityContainers",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "condition": "getContainers",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v14/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v18/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "args": [
                  (v9/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "totalLinkedSecurityVulnerabilityCount"
              },
              {
                "args": (v36/*: any*/),
                "concreteType": "GraphJiraVulnerabilityConnection",
                "kind": "LinkedField",
                "name": "linkedSecurityVulnerabilitiesByProject",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphJiraVulnerabilityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GraphJiraVulnerability",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                            "kind": "LinkedField",
                            "name": "vulnerability",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "condition": "getContainers",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "ThirdPartySecurityContainer",
                                    "kind": "LinkedField",
                                    "name": "securityContainer",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      (v37/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                "kind": "LinkedField",
                                "name": "identifiers",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                  },
                                  (v37/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                "kind": "LinkedField",
                                "name": "additionalInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "content"
                                  },
                                  (v37/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedJiraIssues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AriGraphRelationship",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "AriGraphRelationshipNode",
                                        "kind": "LinkedField",
                                        "name": "to",
                                        "plural": false,
                                        "selections": [
                                          (v18/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "idsOrAliases",
                                                        "value": [
                                                          "summary",
                                                          "assignee",
                                                          "status",
                                                          "issuetype"
                                                        ]
                                                      }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v18/*: any*/),
                                                              {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v38/*: any*/),
                                                                  (v18/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraStatusField"
                                                      },
                                                      (v18/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "text"
                                                          }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                              (v20/*: any*/),
                                                              (v19/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "picture"
                                                              },
                                                              (v18/*: any*/)
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                  }
                                                                ]
                                                              },
                                                              (v18/*: any*/)
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                      }
                                                    ],
                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                  },
                                                  (v38/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                  }
                                                ],
                                                "type": "JiraIssue"
                                              },
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v29/*: any*/),
                                              (v30/*: any*/),
                                              (v31/*: any*/),
                                              (v32/*: any*/),
                                              (v33/*: any*/),
                                              (v34/*: any*/),
                                              (v35/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v15/*: any*/)
                                ]
                              },
                              (v18/*: any*/),
                              (v37/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "introducedDate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "providerVulnerabilityId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "securityContainerId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "severity"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              }
                            ]
                          },
                          (v18/*: any*/),
                          (v20/*: any*/)
                        ]
                      },
                      (v39/*: any*/)
                    ]
                  },
                  (v40/*: any*/)
                ]
              },
              {
                "args": (v36/*: any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "security__linkedSecurityVulnerabilitiesByProject",
                "kind": "LinkedHandle",
                "name": "linkedSecurityVulnerabilitiesByProject"
              },
              {
                "alias": "linkedVulnsForAnalytics",
                "args": (v17/*: any*/),
                "concreteType": "GraphJiraVulnerabilityConnection",
                "kind": "LinkedField",
                "name": "linkedSecurityVulnerabilitiesByProject",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphJiraVulnerabilityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GraphJiraVulnerability",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "getContainers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                "kind": "LinkedField",
                                "name": "vulnerability",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "ThirdPartySecurityContainer",
                                    "kind": "LinkedField",
                                    "name": "securityContainer",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v18/*: any*/)
                                    ]
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v18/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "getContainers",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "AriGraphRelationshipConnection",
                    "kind": "LinkedField",
                    "name": "linkedSecurityContainers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationshipEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationship",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AriGraphRelationshipNode",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v19/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "icon"
                                          },
                                          (v37/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "providerName"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "lastUpdated"
                                          },
                                          (v15/*: any*/),
                                          (v18/*: any*/)
                                        ],
                                        "type": "ThirdPartySecurityContainer"
                                      },
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v20/*: any*/)
                            ]
                          },
                          (v39/*: any*/)
                        ]
                      },
                      (v40/*: any*/)
                    ]
                  },
                  {
                    "args": (v11/*: any*/),
                    "handle": "connection",
                    "key": "security__linkedSecurityContainers",
                    "kind": "LinkedHandle",
                    "name": "linkedSecurityContainers"
                  }
                ]
              },
              {
                "condition": "isVulnsListFixEnabled",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "projectHaveVulnerabilityCheckFirst",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      }
                    ],
                    "concreteType": "GraphJiraVulnerabilityConnection",
                    "kind": "LinkedField",
                    "name": "linkedSecurityVulnerabilitiesByProject",
                    "plural": false,
                    "selections": (v41/*: any*/),
                    "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                  }
                ]
              },
              {
                "condition": "isVulnsListFixEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "projectHaveVulnerabilityCheck",
                    "concreteType": "GraphJiraVulnerabilityConnection",
                    "kind": "LinkedField",
                    "name": "linkedSecurityVulnerabilitiesByProject",
                    "plural": false,
                    "selections": (v41/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      },
      (v21/*: any*/)
    ]
  },
  "params": {
    "id": "cc10cd43053a8820b5cdd778d95d9c93f16c20b4910bb0240ea20f73dbdfb458",
    "metadata": {},
    "name": "mainSecurityInJiraQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "13b399a98e02ad00fbb7180d9f2cb96e";

export default node;
